// extracted by mini-css-extract-plugin
export var filterIncDec = "_4m-0";
export var leftBorder = "_4m-1";
export var rightBorder = "_4m-2";
export var stringInput = "_4m-3";